import { Component, OnInit } from '@angular/core';
import { UsuariosInterface } from './models/usuarios.model';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { ChipComponent } from 'app/modules/global-components/chip/chip.component';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { AgregarUsuarioComponent } from './agregar-usuario/agregar-usuario.component';
import { UsuariosService } from './usuarios.service';
import { UsuarioModel } from './models/usuario-form.model';
import { ApiService } from 'app/core/services/api.service';
import { environment } from 'enviroments/environment';
import { ResponseInterface } from 'app/modules/models/response.model';
import { ControlAccesoDirective } from 'app/shared/directives/control-acceso.directive';

@Component({
    selector: 'usuarios',
    templateUrl: 'usuarios.component.html',
    standalone: true,
    imports:[
        CommonModule,
        MatButtonModule,
        MatMenuModule,
        MatIconModule,
        MatTableModule,
        ChipComponent,
        MatDialogModule,
        ControlAccesoDirective
    ]
})

export class UsuariosComponent implements OnInit {
    usuarios: UsuarioModel[] = [];
    usuariosPorEstado: { titulo: string; lista: UsuarioModel[] }[] = [];
    displayedColumns: string[] = ['usuario', 'dependencia', 'acciones'];
    readonly environment = environment;
    constructor(
        private dialog: MatDialog,
        private _usuariosService: UsuariosService,
        private _apiService: ApiService
    ) {
        this.getUsuarios()
    }

    ngOnInit() { }

    remove(usuario: UsuariosInterface): void {
        console.log('Solicitar eliminar usuario:', usuario);
    }

    getInicial(nombre: string): string {
        if (!nombre) { return ''; }
        const t = nombre.trim();
        return t ? t.charAt(0).toUpperCase() : '';
    }

    openAgregarUsuario(): void {
        const ref = this.dialog.open(AgregarUsuarioComponent, {
            width: '640px',
            maxWidth: '95vw'
        });
        ref.afterClosed().subscribe((ok) => {
            if (ok) {
                this.getUsuarios();
            }
        });
    }

    getUsuarios(){
        this._usuariosService.getUsuarios()
        .then((response: UsuarioModel[])=>{
            this.usuarios = response;
            this.clasificarUsuarios();
        });
    }

    private clasificarUsuarios(): void {
        const activos: UsuarioModel[] = [];
        const inactivos: UsuarioModel[] = [];

        for (const usuario of this.usuarios) {
            if (this.isUsuarioActivo(usuario)) {
                activos.push(usuario);
            } else {
                inactivos.push(usuario);
            }
        }

        this.usuariosPorEstado = [];

        if (activos.length) {
            this.usuariosPorEstado.push({
                titulo: 'Activos',
                lista: activos
            });
        }

        if (inactivos.length) {
            this.usuariosPorEstado.push({
                titulo: 'Inactivos',
                lista: inactivos
            });
        }
    }

    openEditarUsuario(usuario: UsuarioModel): void {
        const ref = this.dialog.open(AgregarUsuarioComponent, {
            width: '640px',
            maxWidth: '95vw',
            data: usuario
        });
        ref.afterClosed().subscribe((ok) => {
            if (ok) this.getUsuarios();
        });
    }

    isUsuarioActivo(usuario: UsuarioModel): boolean {
        return usuario.estado?.tipologiaId === environment.ESTADO_USUARIO_ACTIVO;
    }

    openConfirmarEstadoUsuario(usuario: UsuarioModel): void {
        const activo = this.isUsuarioActivo(usuario);
        const accionTexto = activo ? 'inactivar' : 'activar';

        const message = `¿Desea ${accionTexto} el usuario ${usuario.nombreCompleto}?`;

        this._apiService.open_confirm_dialog(message).subscribe((confirmado) => {
            if (confirmado) {
                this.editarEstadoUsuario(usuario);
            }
        });
    }

    editarEstadoUsuario(usuario: UsuarioModel): void {
        const activo = this.isUsuarioActivo(usuario);
        const nuevoEstadoId = activo
            ? environment.ESTADO_USUARIO_INACTIVO
            : environment.ESTADO_USUARIO_ACTIVO;

        const params = { Estado: nuevoEstadoId };

        this._usuariosService.actualizarUsuario(usuario.usuarioId, params)
            .then((response: ResponseInterface) => {
                this._apiService.showSuccessMessage(response.message);
                this.getUsuarios();
            });
    }
}
